import React, { useState } from "react";
import { useAlert } from "react-alert";
import useConfirmDelete from "../../../utils/withConfirmDelete";
import axios from "../../../plugins/axios";
import { Button } from "djinn-components";
import FormHolder from "../FormHolder";
import { useNavigate } from "react-router-dom";
import { useProjectState } from "../../../utils/requiresProject";

const DeleteProjectVersion = () => {
  const { project } = useProjectState();
  const alert = useAlert();
  const navigate = useNavigate();
  const [apiLoading, setApiLoading] = useState(false);

  const deleteProject = useConfirmDelete();

  const deleteProjectAPI = async () => {
    setApiLoading(true);

    try {
      await axios.delete(`project-versions/${project.id}`);
      alert.show(`Project version (${project.name}) deleted successfully`, {
        type: "success"
      });
      navigate("/");
    } catch (error) {
      alert.show("Filed to delete project version", { type: "error" });
    }
    setApiLoading(false);
  };
  return (
    <FormHolder>
      <div className=" rounded-xl shadow-sm p-10 flex flex-col justify-center items-center text-center">
        <h5 className="text-xl text-white font-medium">
          Delete Version: {project.name}
        </h5>
        <p className="w-2/3 mb-4 mt-2 text-gray-450 text-sm font-light">
          This will delete the selected project version and redirect you to the
          project select page.
        </p>
        <div className="w-32">
          <Button
            text="Delete Version"
            type="button"
            onClick={() => deleteProject("DELETE VERSION", deleteProjectAPI)}
            buttonStyle="red"
            disabled={apiLoading}
            loading={apiLoading}
          />
        </div>
      </div>
    </FormHolder>
  );
};

export default DeleteProjectVersion;
